import React from 'react';

/**
 * Chevron pair (» style) rendered as a compact SVG.
 * Points upward by default; CSS rotates it per side.
 */
function EdgeHintChevrons() {
  return (
    <svg
      className="flowchart__edge-hint-chevrons"
      viewBox="0 0 20 18"
      width={20}
      height={18}
      aria-hidden
    >
      <polyline points="4,12 10,6 16,12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.55" />
      <polyline points="4,16 10,10 16,16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/**
 * Glassy pill indicators at viewport edges while dragging a dependency line (auto-pan hint).
 */
function ConnectionEdgeHints() {
  return (
    <div className="flowchart__connection-edge-hints" aria-hidden>
      <div className="flowchart__connection-edge-hint flowchart__connection-edge-hint--top">
        <EdgeHintChevrons />
      </div>
      <div className="flowchart__connection-edge-hint flowchart__connection-edge-hint--bottom">
        <EdgeHintChevrons />
      </div>
      <div className="flowchart__connection-edge-hint flowchart__connection-edge-hint--left">
        <EdgeHintChevrons />
      </div>
      <div className="flowchart__connection-edge-hint flowchart__connection-edge-hint--right">
        <EdgeHintChevrons />
      </div>
    </div>
  );
}

/**
 * Contextual hints shown during various flowchart interactions
 */
export function FlowchartHints({ isConnecting, selectedEdge }) {
  return (
    <>
      {isConnecting && (
        <>
          <ConnectionEdgeHints />
          <div className="flowchart__hint flowchart__hint--connecting">
            Drop on a mission to connect • Drag to the edge to reach off-screen missions
          </div>
        </>
      )}
      {selectedEdge && (
        <div className="flowchart__hint flowchart__hint--edge">
          Drag the arrowhead to reattach • Press Delete to remove
        </div>
      )}
    </>
  );
}

export default FlowchartHints;

